module.exports = __webpack_public_path__ + "static/media/check_white.2237d6a8.svg";